import type React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

interface StepFooterProps {
  isSubmitting?: boolean;
  onBack?: () => void;
  onSaveDraft?: () => void;
  onNext?: () => void;
  nextDisabled?: boolean;
  saveDraftDisabled?: boolean;
  backDisabled?: boolean;
  nextLabel?: string;
  showSaveDraft?: boolean;
  showBack?: boolean;
}

export const StepFooter: React.FC<StepFooterProps> = ({
  isSubmitting = false,
  onBack,
  onSaveDraft,
  onNext,
  nextDisabled = false,
  saveDraftDisabled = false,
  backDisabled = false,
  nextLabel,
  showSaveDraft = true,
  showBack = true,
}) => {
  const { t } = useTranslation();
  // nextLabelが指定されていない場合は翻訳されたデフォルト値を使用
  const finalNextLabel = nextLabel || t("common.next");

  return (
    <div className="flex justify-between">
      {showBack ? (
        <Button
          onClick={onBack}
          variant="rw-off-white"
          size="sm"
          shaped
          disabled={isSubmitting || backDisabled}
        >
          {t("common.back")}
        </Button>
      ) : (
        <div />
      )}

      <div className="flex items-center gap-3">
        {showSaveDraft && onSaveDraft && (
          <Button
            variant="ghost"
            size="sm"
            shaped
            onClick={onSaveDraft}
            disabled={isSubmitting || saveDraftDisabled}
          >
            {t("common.saveDraft")}
          </Button>
        )}

        {onNext && (
          <Button
            onClick={onNext}
            variant="rw-sub"
            size="sm"
            shaped
            disabled={isSubmitting || nextDisabled}
          >
            {finalNextLabel}
          </Button>
        )}
      </div>
    </div>
  );
};
